import React from "react";

import MultipleSelectionAttributeCard from "./Components/MultipleSelectionAttributeCard";

import { type AppUserSession } from "@/schemas/auth/session";
import {
  Interest,
  UserInterestAttributeSet,
} from "@/schemas/profile/attributes/UserInterestAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type InterestProps = {
  session: AppUserSession;
  values: Interest[];
};

function InterestSelection({
  session,
  values,
}: InterestProps): React.JSX.Element {
  const items = values.map((id) => UserInterestAttributeSet.map[id]);
  const typedValues = items.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <MultipleSelectionAttributeCard
      session={session}
      title={"Interests"}
      icon={"list-outline"}
      attribute={UserInterestAttributeSet}
      values={typedValues}
    />
  );
}

export default InterestSelection;
